import "./Banner.css";
function Banner() {
  return (
    <>
      <div id="banner">
        <h1>Delicious Food, Delivered To You</h1>
        <div>
          <p>
            Choose your favorite meal from our broad selection of available
            meals and enjoy a delicious lunch or dinner at home.
          </p>
          <p>
            All our meals are cooked with high-quality ingredients, just-in-time
            and of course by experienced chefs!
          </p>
        </div>
      </div>
    </>
  );
}
export default Banner;
